import React from 'react';

const Close = ({ fill = 'black', width = 13, height = 13 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 13 13'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.338 3.14645C10.5344 3.34171 10.5344 3.65829 10.338 3.85355L4.30245 9.85355C4.10603 10.0488 3.78758 10.0488 3.59116 9.85355C3.39474 9.65829 3.39474 9.34171 3.59116 9.14645L9.62666 3.14645C9.82308 2.95118 10.1415 2.95118 10.338 3.14645Z'
                fill={fill}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.59116 3.14645C3.78758 2.95118 4.10603 2.95118 4.30245 3.14645L10.338 9.14645C10.5344 9.34171 10.5344 9.65829 10.338 9.85355C10.1415 10.0488 9.82308 10.0488 9.62666 9.85355L3.59116 3.85355C3.39474 3.65829 3.39474 3.34171 3.59116 3.14645Z'
                fill={fill}
            />
        </svg>
    );
};

export default Close;
